import type Api from 'common/lib/api';

const getBalanceHistoryApi = (api: Api) => ({
  // FormData is required since it's a file upload
  // Arguments are file: File, account_id: string, preivew: boolean
  uploadBalanceHistory: (data: FormData) => api.post('/account-balance-history/upload/', { data }),
});

export default getBalanceHistoryApi;
